(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["asp-quick-buy-global"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__ASPQuickBuy && window.__ASPQuickBuy.ready) return;

    var root = null;
    var config = {};
    var currentProduct = null;
    var selectedOptions = [];
    var currentAction = "add_to_cart";
    var bound = false;
    var lastHandle = null;
    var lastTriggerBtn = null;
    var galleryState = { index: 0, count: 0, bound: false, colorHandle: "" };

    var swatchColorAliases = {
      black: "negro", noir: "negro", white: "blanco", blanc: "blanco",
      pink: "rosa", rose: "rosa", lilac: "lila", carne: "nude",
      navy: "marino", "azul-marino": "marino",
      violet: "violeta", "sky-blue": "azul-cielo"
    };

    function handleizeColor(value) {
      if (!value) return "";
      return value
        .toString()
        .toLowerCase()
        .trim()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");
    }

    function isMallaProduct(product) {
      if (!product || !product.handle) return false;
      var handles = config.mallaProductHandles || ["malla-odaki"];
      return handles.indexOf(product.handle) !== -1;
    }

    function isZapatillaLona(product) {
      if (!product || !product.handle) return false;
      var handles = config.zapatillaLonaHandles || ["zapatilla-lona", "zapatillas-de-lona"];
      return handles.indexOf(product.handle) !== -1;
    }

    function isFaldaFolklore(product) {
      if (!product || !product.handle) return false;
      var handles = config.faldaFolkloreHandles || ["falda-de-folklore"];
      return handles.indexOf(product.handle) !== -1;
    }

    function isPantalonJareta(product) {
      if (!product || !product.handle) return false;
      var handles = config.pantalonJaretaHandles || ["pantalon-de-jareta"];
      return handles.indexOf(product.handle) !== -1;
    }

    function isPlayeras(product) {
      if (!product || !product.handle) return false;
      var handles = config.playerasHandles || [
        "playera-sin-manga-licra-transparente",
        "playera-manga-larga-licra-transparente"
      ];
      return handles.indexOf(product.handle) !== -1;
    }

    function isUnitardo(product) {
      if (!product || !product.handle) return false;
      if (String(product.handle).indexOf("unitardo") !== -1) return true;
      var handles = config.unitardoHandles || [
        "unitardo-tirante-espagueti",
        "unitardo-manga-larga",
        "unitardo-tirante-camiseta"
      ];
      return handles.indexOf(product.handle) !== -1;
    }

    function isLeotardoVelur(product) {
      if (!product || !product.handle) return false;
      var handles = config.leotardoVelurHandles || ["leotardo-velur"];
      return handles.indexOf(product.handle) !== -1;
    }

    function isLeotardoDucrox(product) {
      if (!product || !product.handle) return false;
      var handles = config.leotardoDucroxHandles || ["leotardo-ducrox"];
      return handles.indexOf(product.handle) !== -1;
    }

    function showsAllProductColors(product) {
      return isFaldaFolklore(product);
    }

    function getSwatchPalette(product) {
      if (isFaldaFolklore(product) || isLeotardoVelur(product) || isLeotardoDucrox(product)) {
        return config.swatchColorsFalda || {};
      }
      if (isMallaProduct(product)) {
        return config.swatchColorsMalla || {};
      }
      return config.swatchColorsDefault || {};
    }

    function getSwatchColor(value, product) {
      var palette = getSwatchPalette(product || currentProduct);
      var handle = handleizeColor(value);
      if (palette[handle]) return palette[handle];

      var aliases = swatchColorAliases;
      if (isMallaProduct(product || currentProduct)) {
        aliases = Object.assign({}, swatchColorAliases, { lila: "salmon", lilac: "salmon" });
      }
      if (aliases[handle] && palette[aliases[handle]]) return palette[aliases[handle]];
      if (handle.indexOf("salm") === 0 && palette.salmon) return palette.salmon;

      return "#d8d8d8";
    }

    function readConfig() {
      var node = document.getElementById("asp-quick-buy-config");
      if (!node) return {};
      try { return JSON.parse(node.textContent || "{}"); } catch (e) { return {}; }
    }

    function cartRoot() {
      var rootPath = "/";
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        rootPath = window.Shopify.routes.root;
      }
      if (rootPath.charAt(rootPath.length - 1) !== "/") rootPath += "/";
      return rootPath;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      var n = Number(number);
      var p = precision == null ? 2 : precision;
      var t = thousands == null ? "," : thousands;
      var d = decimal == null ? "." : decimal;

      if (!isFinite(n) || !isFinite(p)) return "0";

      var fixed = n.toFixed(p).split(".");
      var dollars = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, t);
      var centsPart = fixed[1] ? d + fixed[1] : "";
      return dollars + centsPart;
    }

    function formatMoney(cents, moneyFormat) {
      var format = moneyFormat || "${{amount}}";
      var value = Number(cents);
      if (!isFinite(value)) value = 0;
      var amount = value / 100;

      return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, token) {
        switch (token) {
          case "amount":
            return formatWithDelimiters(amount, 2, ",", ".");
          case "amount_no_decimals":
            return formatWithDelimiters(amount, 0, ",", ".");
          case "amount_with_comma_separator":
            return formatWithDelimiters(amount, 2, ".", ",");
          case "amount_no_decimals_with_comma_separator":
            return formatWithDelimiters(amount, 0, ".", ",");
          case "amount_with_apostrophe_separator":
            return formatWithDelimiters(amount, 2, "'", ".");
          case "amount_with_space_separator":
            return formatWithDelimiters(amount, 2, " ", ",");
          case "amount_no_decimals_with_space_separator":
            return formatWithDelimiters(amount, 0, " ", ",");
          default:
            return formatWithDelimiters(amount, 2, ",", ".");
        }
      });
    }

    function ensureRoot() {
      root = document.getElementById("asp-global-quick-buy");
      if (!root) root = document.querySelector("[data-asp-quick-buy]");
      if (root && root.parentElement !== document.body) {
        document.body.appendChild(root);
      }
      return root;
    }

    function qs(sel) {
      return root ? root.querySelector(sel) : null;
    }

    function setPanelState(state) {
      var loading = qs("[data-asp-qb-loading]");
      var content = qs("[data-asp-qb-content]");
      var error = qs("[data-asp-qb-error]");
      if (loading) loading.hidden = state !== "loading";
      if (content) content.hidden = state !== "content";
      if (error) error.hidden = state !== "error";
      if (root) root.classList.toggle("is-loading", state === "loading");
    }

    function openOverlay() {
      if (!ensureRoot()) return;
      root.classList.add("is-open");
      root.setAttribute("aria-hidden", "false");
      document.documentElement.classList.add("asp-qb-lock");
    }

    function closeOverlay() {
      if (!root) return;
      root.classList.remove("is-open", "is-loading");
      root.setAttribute("aria-hidden", "true");
      document.documentElement.classList.remove("asp-qb-lock");
      setPanelState("content");
    }

    function showError(message) {
      var errorText = qs("[data-asp-qb-error-text]");
      if (errorText) errorText.textContent = message || config.labelError || "Error";
      setPanelState("error");
    }

    function labelsFromBtn(btn) {
      var ctx = btn ? btn.closest("[data-gp5-quick-buy-root]") : null;
      return {
        moneyFormat: (ctx && ctx.dataset.moneyFormat) || config.moneyFormat || "${{amount}}",
        labelAdd: (ctx && ctx.dataset.labelAdd) || config.labelAdd || "Anadir al carrito",
        labelBuy: (ctx && ctx.dataset.labelBuy) || config.labelBuy || "Comprar ahora",
        labelSoldOut: (ctx && ctx.dataset.labelSoldOut) || config.labelSoldOut || "Agotado",
        labelAdding: (ctx && ctx.dataset.labelAdding) || config.labelAdding || "Anadiendo...",
        labelAdded: (ctx && ctx.dataset.labelAdded) || config.labelAdded || "Anadido"
      };
    }

    function getOptionNames(product) {
      if (!product || !product.options) return [];
      return product.options.map(function (option, index) {
        if (typeof option === "string") return option;
        if (option && option.name) return option.name;
        return "Option " + (index + 1);
      });
    }

    function normalizeProduct(product) {
      if (!product) return null;
      product.options = getOptionNames(product);
      if (!product.variants) product.variants = [];
      if (!product.images) product.images = [];
      if (!product.colorGallery) {
        product.colorGallery = buildColorGalleryFromConfig(product);
      }
      if (product.colorOptionIndex == null) {
        product.colorOptionIndex = detectColorOptionIndex(product);
      }
      return product;
    }

    function readEmbeddedProduct(handle, triggerBtn) {
      if (!handle) return null;
      var card = triggerBtn ? triggerBtn.closest(".asp__card, .gp5__card, .asp__media, .gp5__media") : null;
      var scope = card || document;
      var node = scope.querySelector('[data-asp-product-data="' + handle + '"]');
      if (!node) node = document.querySelector('[data-asp-product-data="' + handle + '"]');
      if (!node) return null;
      try {
        return normalizeProduct(JSON.parse(node.textContent || "{}"));
      } catch (e) {
        return null;
      }
    }

    function fetchProduct(handle) {
      var url = cartRoot() + "products/" + encodeURIComponent(handle) + ".js";
      return fetch(url, {
        credentials: "same-origin",
        headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" }
      }).then(function (res) {
        if (!res.ok) throw new Error("fetch failed");
        return res.json();
      }).then(function (product) {
        return normalizeProduct(product);
      });
    }

    function loadProduct(handle, triggerBtn) {
      var embedded = readEmbeddedProduct(handle, triggerBtn);
      if (embedded && embedded.variants && embedded.variants.length) {
        return Promise.resolve(embedded);
      }
      return fetchProduct(handle);
    }

    function isColorOption(name) {
      var key = (name || "").toLowerCase();
      return key.indexOf("color") !== -1 || key.indexOf("colour") !== -1 || key.indexOf("colores") !== -1;
    }

    function isSizeOption(name) {
      var key = (name || "").toLowerCase();
      return key.indexOf("talla") !== -1 || key.indexOf("size") !== -1 || key.indexOf("tamano") !== -1 || key.indexOf("tamaño") !== -1;
    }

    function allowedSizes(product) {
      if (isZapatillaLona(product || currentProduct)) {
        return config.zapatillaLonaSizes || ["20", "20.5", "21", "21.5", "22", "22.5", "23", "23.5", "24", "24.5", "25", "25.5", "26", "26.5"];
      }
      if (isPantalonJareta(product || currentProduct)) {
        return config.pantalonJaretaSizes || ["S", "M", "L", "XL"];
      }
      if (isPlayeras(product || currentProduct)) {
        return config.playerasSizes || ["S", "M", "L", "XL"];
      }
      if (isUnitardo(product || currentProduct)) {
        return config.unitardoSizes || ["S", "M", "L", "XL"];
      }
      if (isLeotardoVelur(product || currentProduct)) {
        return config.leotardoVelurSizes || ["S", "M", "L", "XL"];
      }
      if (config.allowedSizes && config.allowedSizes.length) return config.allowedSizes;
      return ["8", "10", "12", "S", "M", "L", "XL"];
    }

    function allowedColorGroups() {
      var raw = config.allowedColors || "negro|black|noir,blanco|white|blanc,rosa|pink|rose,nude|carne,lila|lilac";
      return raw.split(",").map(function (group) {
        return group.split("|").map(function (alias) {
          return alias.trim().toLowerCase();
        }).filter(Boolean);
      });
    }

    function allowedColorGroupsForProduct(product) {
      if (isZapatillaLona(product)) {
        var zapRaw = config.zapatillaLonaColors || "negro|Negro|black,salmon|Salmón|Salmon|salmón";
        return zapRaw.split(",").map(function (group) {
          return group.split("|").map(function (alias) {
            return alias.trim().toLowerCase();
          }).filter(Boolean);
        });
      }
      if (isPantalonJareta(product)) {
        var jaretaRaw = config.pantalonJaretaColors || "negro|Negro|black";
        return jaretaRaw.split(",").map(function (group) {
          return group.split("|").map(function (alias) {
            return alias.trim().toLowerCase();
          }).filter(Boolean);
        });
      }
      if (isPlayeras(product)) {
        var playerasRaw = config.playerasColors || "negro|Negro|black";
        return playerasRaw.split(",").map(function (group) {
          return group.split("|").map(function (alias) {
            return alias.trim().toLowerCase();
          }).filter(Boolean);
        });
      }
      if (isUnitardo(product)) {
        var unitardoRaw = config.unitardoColors || "negro|black|noir,blanco|white|blanc,rosa|pink|rose,nude|carne,lila|lilac,marino|Marino|azul-marino|Azul marino|navy";
        return unitardoRaw.split(",").map(function (group) {
          return group.split("|").map(function (alias) {
            return alias.trim().toLowerCase();
          }).filter(Boolean);
        });
      }
      if (isLeotardoVelur(product)) {
        var velurRaw = config.leotardoVelurColors || "vino|Vino|wine,gris|Gris|gray|grey,palo-de-rosa|Palo de rosa|Palo de Rosa|palo de rosa";
        return velurRaw.split(",").map(function (group) {
          return group.split("|").map(function (alias) {
            return alias.trim().toLowerCase();
          }).filter(Boolean);
        });
      }
      if (isLeotardoDucrox(product)) {
        var ducroxRaw = config.leotardoDucroxColors || "azul-cielo|Azul cielo|Azul Cielo|sky-blue|Sky Blue|sky blue,violeta|Violeta|violet|Violet";
        return ducroxRaw.split(",").map(function (group) {
          return group.split("|").map(function (alias) {
            return alias.trim().toLowerCase();
          }).filter(Boolean);
        });
      }
      if (isMallaProduct(product)) {
        var mallaRaw = config.allowedColorsMalla || config.allowedColors || "";
        return mallaRaw.split(",").map(function (group) {
          return group.split("|").map(function (alias) {
            return alias.trim().toLowerCase();
          }).filter(Boolean);
        });
      }
      return allowedColorGroups();
    }

    function detectColorOptionIndex(product) {
      if (!product) return -1;
      if (product.colorOptionIndex != null && product.colorOptionIndex >= 0) {
        return product.colorOptionIndex;
      }
      var names = getOptionNames(product);
      for (var i = 0; i < names.length; i++) {
        if (isColorOption(names[i])) return i;
      }
      return -1;
    }

    function canonicalColorHandle(colorValue, product) {
      var normalized = handleizeColor(colorValue);
      if (!normalized) return "";
      var groups = allowedColorGroupsForProduct(product || currentProduct);
      for (var g = 0; g < groups.length; g++) {
        var aliases = groups[g];
        for (var a = 0; a < aliases.length; a++) {
          if (handleizeColor(aliases[a]) === normalized) {
            return handleizeColor(aliases[0]);
          }
        }
      }
      return normalized;
    }

    function parseSequentialColorMap(mapString, imageCount) {
      var result = {};
      if (!mapString || !imageCount) return result;
      mapString.split("||").forEach(function (row) {
        if (!row) return;
        var bits = row.split("|");
        var handle = bits[0] ? bits[0].trim() : "";
        var nums = bits[1] ? bits[1].trim() : "";
        if (!handle || !nums) return;
        result[handle] = nums.split(",").map(function (num) {
          var index = parseInt(num.trim(), 10) - 1;
          if (isNaN(index) || index < 0 || index >= imageCount) return null;
          return index;
        }).filter(function (index) {
          return index !== null;
        });
      });
      return result;
    }

    function buildColorGalleryFromConfig(product) {
      var count = product && product.images ? product.images.length : 0;
      if (!count) return null;
      var mapString;
      if (isLeotardoDucrox(product)) {
        mapString = config.colorGalleryMapDucrox;
      } else if (isUnitardo(product)) {
        mapString = config.colorGalleryMapUnitardo;
      } else if (isMallaProduct(product)) {
        mapString = config.colorGalleryMapMalla;
      } else {
        mapString = config.colorGalleryMapDefault;
      }
      var parsed = parseSequentialColorMap(mapString, count);
      return Object.keys(parsed).length ? parsed : null;
    }

    function getSelectedColorHandle(product) {
      var colorIndex = detectColorOptionIndex(product);
      if (colorIndex < 0) return "";
      var value = selectedOptions[colorIndex];
      if (!value) return "";
      return canonicalColorHandle(value, product);
    }

    function normalizeSizeKey(value) {
      return String(value || "").trim().toUpperCase();
    }

    function normalizeColorKey(value) {
      return String(value || "").trim().toLowerCase();
    }

    function filterSizeValues(valuesMap, product) {
      var byKey = {};
      Object.keys(valuesMap).forEach(function (value) {
        byKey[normalizeSizeKey(value)] = value;
      });
      return allowedSizes(product).map(function (allowed) {
        return byKey[normalizeSizeKey(allowed)];
      }).filter(Boolean);
    }

    function matchColorValue(valuesMap, aliases) {
      var keys = Object.keys(valuesMap);
      for (var i = 0; i < keys.length; i++) {
        var key = normalizeColorKey(keys[i]);
        for (var j = 0; j < aliases.length; j++) {
          if (key === aliases[j]) return keys[i];
        }
      }
      // Accent-insensitive fallback (e.g. Salmón vs salmon)
      for (var k = 0; k < keys.length; k++) {
        var keyHandle = handleizeColor(keys[k]);
        for (var a = 0; a < aliases.length; a++) {
          if (keyHandle && keyHandle === handleizeColor(aliases[a])) return keys[k];
        }
      }
      return null;
    }

    function filterColorValues(valuesMap, product) {
      return allowedColorGroupsForProduct(product || currentProduct).map(function (aliases) {
        return matchColorValue(valuesMap, aliases);
      }).filter(Boolean);
    }

    function ensureAllowedOptionSelection(product, matcher, isOption) {
      var optionNames = getOptionNames(product);
      optionNames.forEach(function (optionName, optionIndex) {
        if (!isOption(optionName)) return;

        var values = {};
        product.variants.forEach(function (variant) {
          var val = variant["option" + (optionIndex + 1)];
          if (val) values[val] = true;
        });

        var allowed = matcher(values, product);
        if (!allowed.length) return;

        var current = selectedOptions[optionIndex];
        var currentAllowed = allowed.some(function (value) {
          return matcher === filterSizeValues
            ? normalizeSizeKey(value) === normalizeSizeKey(current)
            : allowed.indexOf(current) !== -1;
        });

        if (currentAllowed) return;

        for (var i = 0; i < allowed.length; i++) {
          var test = selectedOptions.slice();
          test[optionIndex] = allowed[i];
          var match = product.variants.find(function (variant) {
            return test.every(function (opt, idx) {
              return variant["option" + (idx + 1)] === opt;
            });
          });
          if (match) {
            selectedOptions[optionIndex] = allowed[i];
            return;
          }
        }

        selectedOptions[optionIndex] = allowed[0];
      });
    }

    function ensureAllowedSizeSelection(product) {
      ensureAllowedOptionSelection(product, filterSizeValues, isSizeOption);
    }

    function ensureAllowedColorSelection(product) {
      ensureAllowedOptionSelection(product, filterColorValues, isColorOption);
    }

    function slugify(v) {
      return handleizeColor(v);
    }

    function findVariant(product) {
      if (!product || !product.variants) return null;
      return product.variants.find(function (v) {
        return selectedOptions.every(function (val, i) {
          return v["option" + (i + 1)] === val;
        });
      });
    }

    function imageUrl(image) {
      if (!image) return "";
      if (typeof image === "string") return image;
      if (image.src) return image.src;
      return "";
    }

    function escapeHtml(str) {
      return String(str || "")
        .replace(/&/g, "&amp;")
        .replace(/"/g, "&quot;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");
    }

    function normalizeImageSrc(src) {
      var value = imageUrl(src);
      if (!value) return "";
      return value.split("?")[0].split("#")[0];
    }

    function getAllProductImages(product) {
      var urls = [];
      var seen = {};
      function add(image) {
        var src = imageUrl(image);
        var key = normalizeImageSrc(src);
        if (!key || seen[key]) return;
        seen[key] = true;
        urls.push(src);
      }
      if (product && product.images && product.images.length) {
        product.images.forEach(add);
      }
      if (!urls.length && product && product.variants) {
        product.variants.forEach(function (variant) {
          if (variant.featured_image) add(variant.featured_image);
        });
      }
      return urls;
    }

    function faldaColorFilenameTokens(colorHandle) {
      var handle = handleizeColor(colorHandle);
      var map = {
        negro: ["negra", "negro"],
        blanco: ["blanca", "blanco"],
        fucsia: ["fiusha", "fucsia", "fuschia", "fuchsia"],
        anaranjado: ["naranja", "anaranjado"],
        "v-agua": ["verde_agua", "verde-agua", "v_agua", "v-agua"],
        rosa: ["rosa_pastel", "rosa-pastel", "rosapastel", "rosa"],
        "palo-de-rosa": ["paloderosa", "palo_de_rosa", "palo-de-rosa", "palo_rosa", "palo-rosa"],
        "azul-petroleo": ["azul_petroleo", "azul-petroleo"],
        "azul-rey": ["azul_rey", "azul-rey"],
        "azul-cielo": ["azul_cielo", "azul-cielo"],
        marino: ["marino", "azul_marino", "azul-marino"],
        "x-tono": ["x_tono", "x-tono", "xtono"]
      };
      if (map[handle]) return map[handle];
      if (!handle) return [];
      return [handle, handle.replace(/-/g, "_")];
    }

    function findFaldaImageForColor(product, colorHandle) {
      var tokens = faldaColorFilenameTokens(colorHandle);
      if (!tokens.length) return "";
      var handle = handleizeColor(colorHandle);
      var allImages = getAllProductImages(product);
      for (var i = 0; i < allImages.length; i++) {
        var src = normalizeImageSrc(allImages[i]).toLowerCase();
        for (var t = 0; t < tokens.length; t++) {
          if (!tokens[t] || src.indexOf(tokens[t]) === -1) continue;
          if (handle === "rosa" && (src.indexOf("palo_de_rosa") !== -1 || src.indexOf("palo-de-rosa") !== -1 || src.indexOf("paloderosa") !== -1)) {
            continue;
          }
          return allImages[i];
        }
      }
      return "";
    }

    function getGalleryImages(product) {
      var allImages = getAllProductImages(product);
      if (!allImages.length) return [];

      var colorHandle = getSelectedColorHandle(product);

      if (isFaldaFolklore(product) && colorHandle) {
        var faldaSrc = findFaldaImageForColor(product, colorHandle);
        if (faldaSrc) return [faldaSrc];
        var faldaVariant = findVariant(product);
        if (faldaVariant && faldaVariant.featured_image) {
          var faldaFeatured = imageUrl(faldaVariant.featured_image);
          if (faldaFeatured) return [faldaFeatured];
        }
      }

      // Unitardos / Leotardo Velur: one calm photo per color — filename, then variant featured, then map.
      if ((isUnitardo(product) || isLeotardoVelur(product)) && colorHandle) {
        var unitardoSrc = findFaldaImageForColor(product, colorHandle);
        if (unitardoSrc) return [unitardoSrc];
        var unitardoVariant = findVariant(product);
        if (unitardoVariant && unitardoVariant.featured_image) {
          var unitardoFeatured = imageUrl(unitardoVariant.featured_image);
          if (unitardoFeatured) return [unitardoFeatured];
        }
        if (isUnitardo(product)) {
          var unitardoMap = config.colorGalleryMapUnitardo
            ? parseSequentialColorMap(config.colorGalleryMapUnitardo, allImages.length)
            : null;
          if (unitardoMap && unitardoMap[colorHandle] && unitardoMap[colorHandle].length) {
            return unitardoMap[colorHandle].map(function (index) {
              return allImages[index];
            }).filter(Boolean).slice(0, 1);
          }
        }
      }

      var galleryMap = product.colorGallery || buildColorGalleryFromConfig(product);
      var indices = colorHandle && galleryMap ? galleryMap[colorHandle] : null;

      if (indices && indices.length) {
        return indices.map(function (index) {
          return allImages[index];
        }).filter(Boolean);
      }

      if (colorHandle && galleryMap) {
        var variant = findVariant(product);
        if (variant && variant.featured_image) {
          var featuredSrc = imageUrl(variant.featured_image);
          if (featuredSrc) return [featuredSrc];
        }
      }

      return allImages.slice(0, 3);
    }

    function findGalleryIndexForVariant(images, variant) {
      if (!variant || !images.length) return 0;
      var target = normalizeImageSrc(variant.featured_image);
      if (!target) return 0;
      for (var i = 0; i < images.length; i++) {
        if (normalizeImageSrc(images[i]) === target) return i;
      }
      var filename = target.split("/").pop();
      if (filename) {
        for (var j = 0; j < images.length; j++) {
          if (normalizeImageSrc(images[j]).indexOf(filename) !== -1) return j;
        }
      }
      return 0;
    }

    function syncGalleryUI(viewport) {
      var gallery = qs("[data-asp-qb-gallery]");
      if (!gallery) return;
      var slides = gallery.querySelectorAll("[data-asp-qb-gallery-slide]");
      var count = slides.length;
      var index = galleryState.index;
      var hasMultiple = count > 1;
      var nav = gallery.querySelector("[data-asp-qb-gallery-nav]");
      var prev = gallery.querySelector("[data-asp-qb-gallery-prev]");
      var next = gallery.querySelector("[data-asp-qb-gallery-next]");

      if (nav) nav.hidden = !hasMultiple;
      if (prev) prev.hidden = !hasMultiple;
      if (next) next.hidden = !hasMultiple;

      slides.forEach(function (slide, slideIndex) {
        slide.setAttribute("aria-hidden", slideIndex === index ? "false" : "true");
      });

      if (!hasMultiple) return;

      var counter = gallery.querySelector("[data-asp-qb-gallery-counter]");
      if (counter) counter.textContent = (index + 1) + " / " + count;

      gallery.querySelectorAll("[data-asp-qb-gallery-dot]").forEach(function (dot, dotIndex) {
        var active = dotIndex === index;
        dot.classList.toggle("is-active", active);
        dot.setAttribute("aria-current", active ? "true" : "false");
      });

      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === count - 1;
    }

    function goToGallerySlide(index, options) {
      var opts = options || {};
      var gallery = qs("[data-asp-qb-gallery]");
      if (!gallery) return;
      var viewport = gallery.querySelector("[data-asp-qb-gallery-viewport]");
      var slides = gallery.querySelectorAll("[data-asp-qb-gallery-slide]");
      if (!viewport || !slides.length) return;

      var max = slides.length - 1;
      index = Math.max(0, Math.min(index, max));
      galleryState.index = index;
      galleryState.count = slides.length;

      viewport.scrollTo({
        left: index * viewport.clientWidth,
        behavior: opts.instant ? "auto" : "smooth"
      });
      syncGalleryUI(viewport);
    }

    function bindGalleryEvents() {
      if (galleryState.bound) return;
      var gallery = qs("[data-asp-qb-gallery]");
      if (!gallery) return;
      galleryState.bound = true;

      var viewport = gallery.querySelector("[data-asp-qb-gallery-viewport]");
      var prev = gallery.querySelector("[data-asp-qb-gallery-prev]");
      var next = gallery.querySelector("[data-asp-qb-gallery-next]");

      if (prev) {
        prev.addEventListener("click", function () {
          goToGallerySlide(galleryState.index - 1);
        });
      }

      if (next) {
        next.addEventListener("click", function () {
          goToGallerySlide(galleryState.index + 1);
        });
      }

      gallery.querySelectorAll("[data-asp-qb-gallery-dot]").forEach(function (dot, index) {
        dot.addEventListener("click", function () {
          goToGallerySlide(index);
        });
      });

      if (viewport) {
        var scrollTimer;
        viewport.addEventListener("scroll", function () {
          window.clearTimeout(scrollTimer);
          scrollTimer = window.setTimeout(function () {
            if (!viewport.clientWidth) return;
            var nextIndex = Math.round(viewport.scrollLeft / viewport.clientWidth);
            if (nextIndex !== galleryState.index) {
              galleryState.index = nextIndex;
              syncGalleryUI(viewport);
            }
          }, 80);
        }, { passive: true });

        viewport.addEventListener("keydown", function (event) {
          if (event.key === "ArrowLeft") {
            event.preventDefault();
            goToGallerySlide(galleryState.index - 1);
          }
          if (event.key === "ArrowRight") {
            event.preventDefault();
            goToGallerySlide(galleryState.index + 1);
          }
        });
      }
    }

    function renderMediaGallery(product, variant) {
      var qbMedia = qs("[data-asp-qb-media]");
      if (!qbMedia) return;

      var colorHandle = getSelectedColorHandle(product);
      var images = getGalleryImages(product);
      galleryState.bound = false;
      galleryState.index = 0;
      galleryState.count = images.length;
      galleryState.colorHandle = colorHandle;

      if (!images.length) {
        qbMedia.hidden = true;
        qbMedia.innerHTML = "";
        return;
      }

      var alt = product.title || "";
      var slidesHtml = images.map(function (src, index) {
        return (
          '<figure class="asp-qb__gallery-slide" data-asp-qb-gallery-slide aria-hidden="' + (index === 0 ? "false" : "true") + '">' +
            '<img src="' + escapeHtml(src) + '" alt="' + escapeHtml(alt) + '" loading="' + (index === 0 ? "eager" : "lazy") + '" decoding="async">' +
          "</figure>"
        );
      }).join("");

      var dotsHtml = images.length > 1
        ? images.map(function (_, index) {
            return (
              '<button type="button" class="asp-qb__gallery-dot' + (index === 0 ? " is-active" : "") + '" data-asp-qb-gallery-dot aria-label="' + (index + 1) + '" aria-current="' + (index === 0 ? "true" : "false") + '"></button>'
            );
          }).join("")
        : "";

      var navHidden = images.length <= 1 ? " hidden" : "";
      var prevLabel = escapeHtml(config.labelGalleryPrev || "Imagen anterior");
      var nextLabel = escapeHtml(config.labelGalleryNext || "Imagen siguiente");

      qbMedia.innerHTML =
        '<div class="asp-qb__gallery" data-asp-qb-gallery>' +
          '<div class="asp-qb__gallery-viewport" data-asp-qb-gallery-viewport tabindex="0" aria-roledescription="carousel">' +
            '<div class="asp-qb__gallery-track" data-asp-qb-gallery-track>' + slidesHtml + "</div>" +
          "</div>" +
          '<button type="button" class="asp-qb__gallery-arrow asp-qb__gallery-arrow--prev" data-asp-qb-gallery-prev aria-label="' + prevLabel + '"' + navHidden + '>' +
            '<span aria-hidden="true">&#8249;</span>' +
          "</button>" +
          '<button type="button" class="asp-qb__gallery-arrow asp-qb__gallery-arrow--next" data-asp-qb-gallery-next aria-label="' + nextLabel + '"' + navHidden + '>' +
            '<span aria-hidden="true">&#8250;</span>' +
          "</button>" +
          '<div class="asp-qb__gallery-nav" data-asp-qb-gallery-nav' + navHidden + ">" +
            '<span class="asp-qb__gallery-counter" data-asp-qb-gallery-counter aria-live="polite">1 / ' + images.length + "</span>" +
            (dotsHtml ? '<div class="asp-qb__gallery-dots" data-asp-qb-gallery-dots>' + dotsHtml + "</div>" : "") +
          "</div>" +
        "</div>";

      bindGalleryEvents();
      qbMedia.hidden = false;

      var startIndex = findGalleryIndexForVariant(images, variant);
      if (startIndex > 0) {
        requestAnimationFrame(function () {
          goToGallerySlide(startIndex, { instant: true });
        });
      } else {
        syncGalleryUI(qs("[data-asp-qb-gallery-viewport]"));
      }
    }

    function updateMediaGallery(variant) {
      if (!currentProduct) return;
      var colorHandle = getSelectedColorHandle(currentProduct);
      if (!qs("[data-asp-qb-gallery]") || galleryState.colorHandle !== colorHandle) {
        renderMediaGallery(currentProduct, variant);
        return;
      }
      var images = getGalleryImages(currentProduct);
      goToGallerySlide(findGalleryIndexForVariant(images, variant));
    }

    function updateAvailability(qbOptions) {
      if (!currentProduct || !qbOptions) return;
      qbOptions.querySelectorAll("[data-qb-option]").forEach(function (btn) {
        var pos = parseInt(btn.dataset.optionPosition, 10) - 1;
        var test = selectedOptions.slice();
        test[pos] = btn.dataset.value;
        var match = currentProduct.variants.find(function (v) {
          return test.every(function (opt, i) { return v["option" + (i + 1)] === opt; });
        });
        btn.classList.toggle("is-unavailable", !(match && match.available));
      });
    }

    function updateUI(labels) {
      var qbPrice = qs("[data-asp-qb-price]");
      var qbSubmit = qs("[data-asp-qb-submit]");
      var qbMedia = qs("[data-asp-qb-media]");
      var variant = findVariant(currentProduct);

      if (!qbSubmit) return;

      if (!variant) {
        qbSubmit.disabled = true;
        qbSubmit.textContent = labels.labelSoldOut;
        return;
      }

      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (qbPrice) {
        qbPrice.innerHTML = onSale
          ? formatMoney(variant.price, labels.moneyFormat) + " <s>" + formatMoney(variant.compare_at_price, labels.moneyFormat) + "</s>"
          : formatMoney(variant.price, labels.moneyFormat);
      }

      qbSubmit.disabled = !variant.available;
      qbSubmit.textContent = variant.available
        ? (currentAction === "checkout" ? labels.labelBuy : labels.labelAdd)
        : labels.labelSoldOut;

      if (qbMedia) {
        updateMediaGallery(variant);
      }

      updateAvailability(qs("[data-asp-qb-options]"));
    }

    function renderOptions(product, labels) {
      var qbOptions = qs("[data-asp-qb-options]");
      if (!qbOptions) return;
      qbOptions.innerHTML = "";

      var optionNames = getOptionNames(product);
      optionNames.forEach(function (optionName, optionIndex) {
        if (optionName === "Title" && product.variants.length <= 1) return;

        var fieldset = document.createElement("fieldset");
        fieldset.className = "asp-qb__option";
        var legend = document.createElement("legend");
        legend.className = "asp-qb__option-label";
        legend.innerHTML = optionName.toUpperCase() + ": <strong>" + (selectedOptions[optionIndex] || "") + "</strong>";
        fieldset.appendChild(legend);

        var wrap = document.createElement("div");
        wrap.className = "asp-qb__option-values";
        var values = {};
        product.variants.forEach(function (v) {
          var val = v["option" + (optionIndex + 1)];
          if (val) values[val] = true;
        });

        var valueList;
        if (isSizeOption(optionName)) {
          if (isMallaProduct(product)) {
            valueList = Object.keys(values);
          } else {
            valueList = filterSizeValues(values, product);
          }
        } else if (isColorOption(optionName)) {
          if (showsAllProductColors(product)) {
            valueList = Object.keys(values);
          } else {
            valueList = filterColorValues(values, product);
          }
        } else {
          valueList = Object.keys(values);
        }

        valueList.forEach(function (value) {
          var btn = document.createElement("button");
          btn.type = "button";
          btn.dataset.qbOption = "";
          btn.dataset.optionPosition = String(optionIndex + 1);
          btn.dataset.value = value;
          var selected = selectedOptions[optionIndex] === value;
          if (selected) btn.classList.add("is-selected");
          btn.setAttribute("aria-pressed", selected ? "true" : "false");

          if (isColorOption(optionName)) {
            btn.className = "asp-qb__swatch" + (selected ? " is-selected" : "");
            var color = getSwatchColor(value, product);
            btn.innerHTML = '<span class="asp-qb__swatch-dot" style="--swatch-color:' + color + '"></span>';
            btn.setAttribute("aria-label", value);
          } else {
            btn.className = "asp-qb__pill" + (selected ? " is-selected" : "");
            btn.textContent = value;
          }

          btn.addEventListener("click", function () {
            selectedOptions[optionIndex] = value;
            qbOptions.querySelectorAll('[data-option-position="' + (optionIndex + 1) + '"]').forEach(function (el) {
              el.classList.remove("is-selected");
              el.setAttribute("aria-pressed", "false");
            });
            btn.classList.add("is-selected");
            btn.setAttribute("aria-pressed", "true");
            legend.innerHTML = optionName.toUpperCase() + ": <strong>" + value + "</strong>";
            updateUI(labels);
          });

          wrap.appendChild(btn);
        });

        fieldset.appendChild(wrap);
        qbOptions.appendChild(fieldset);
      });
    }

    function renderProduct(product, labels) {
      var first = product.variants.find(function (v) { return v.available; }) || product.variants[0];
      if (!first) throw new Error("no variants");

      selectedOptions = [first.option1, first.option2, first.option3].filter(function (v) {
        return v && v !== "Default Title";
      });

      ensureAllowedSizeSelection(product);
      if (!showsAllProductColors(product)) {
        ensureAllowedColorSelection(product);
      }

      var qbTitle = qs("[data-asp-qb-title]");
      var qbVendor = qs("[data-asp-qb-vendor]");
      var qbQty = qs("[data-asp-qb-qty]");
      var qbView = qs("[data-asp-qb-view]");

      if (qbTitle) qbTitle.textContent = product.title;
      if (qbVendor) {
        if (product.vendor) {
          qbVendor.textContent = product.vendor;
          qbVendor.hidden = false;
        } else {
          qbVendor.hidden = true;
        }
      }
      if (qbView) qbView.href = cartRoot() + "products/" + product.handle;
      if (qbQty) qbQty.value = "1";

      renderOptions(product, labels);
      renderMediaGallery(product, findVariant(product));
      updateUI(labels);
      setPanelState("content");
    }

    function openQuickBuy(handle, action, triggerBtn) {
      if (!handle) return;
      if (!ensureRoot()) return;

      lastHandle = handle;
      lastTriggerBtn = triggerBtn;
      var labels = labelsFromBtn(triggerBtn);
      currentAction = action || "add_to_cart";

      openOverlay();
      setPanelState("loading");

      loadProduct(handle, triggerBtn)
        .then(function (product) {
          if (!product || !product.variants || !product.variants.length) {
            throw new Error("invalid product");
          }
          currentProduct = product;
          renderProduct(product, labels);
        })
        .catch(function () {
          showError(config.labelError);
        });
    }

    function onQuickBuyClick(event) {
      var btn = event.target.closest("[data-asp-open-quick-buy]");
      if (!btn) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      openQuickBuy(
        btn.getAttribute("data-product-handle"),
        btn.getAttribute("data-atc-action") || "add_to_cart",
        btn
      );
    }

    function bindControls() {
      if (!ensureRoot() || bound) return;
      bound = true;

      var closeBtn = qs("[data-asp-qb-close]");
      var backdrop = qs("[data-asp-qb-backdrop]");
      var qbMinus = qs("[data-asp-qb-qty-minus]");
      var qbPlus = qs("[data-asp-qb-qty-plus]");
      var qbQty = qs("[data-asp-qb-qty]");
      var qbSubmit = qs("[data-asp-qb-submit]");

      if (closeBtn) closeBtn.addEventListener("click", closeOverlay);
      if (backdrop) {
        backdrop.addEventListener("click", function () {
          if (root && root.classList.contains("is-loading")) return;
          closeOverlay();
        });
      }

      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && root && root.classList.contains("is-open")) closeOverlay();
      });

      if (qbMinus && qbQty) {
        qbMinus.addEventListener("click", function () {
          qbQty.value = Math.max(1, (parseInt(qbQty.value, 10) || 1) - 1);
        });
      }

      if (qbPlus && qbQty) {
        qbPlus.addEventListener("click", function () {
          qbQty.value = (parseInt(qbQty.value, 10) || 1) + 1;
        });
      }

      if (qbSubmit) {
        qbSubmit.addEventListener("click", function () {
          var variant = findVariant(currentProduct);
          if (!variant || !variant.available) return;
          var labels = labelsFromBtn(lastTriggerBtn);
          var qty = qbQty ? parseInt(qbQty.value, 10) || 1 : 1;
          var original = qbSubmit.textContent;
          qbSubmit.disabled = true;
          qbSubmit.dataset.state = "loading";
          qbSubmit.textContent = labels.labelAdding;

          fetch(cartRoot() + "cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ items: [{ id: parseInt(variant.id, 10), quantity: qty }] })
          })
            .then(function (res) {
              if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || "Error"); });
              return res.json();
            })
            .then(function () {
              if (currentAction === "checkout") {
                window.location.href = cartRoot() + "checkout";
                return null;
              }
              return fetch(cartRoot() + "cart.js");
            })
            .then(function (res) {
              if (!res) return;
              return res.json();
            })
            .then(function (cart) {
              if (cart) {
                document.dispatchEvent(new CustomEvent("cart:updated", { detail: { item_count: cart.item_count } }));
                document.querySelectorAll("[data-count]").forEach(function (el) {
                  el.textContent = cart.item_count;
                  el.dataset.count = cart.item_count;
                });
              }
              qbSubmit.dataset.state = "";
              qbSubmit.textContent = labels.labelAdded;
              setTimeout(function () {
                closeOverlay();
                qbSubmit.disabled = false;
                qbSubmit.textContent = original;
              }, 1000);
            })
            .catch(function () {
              qbSubmit.dataset.state = "";
              qbSubmit.disabled = false;
              qbSubmit.textContent = original;
            });
        });
      }
    }

    function init() {
      config = readConfig();
      ensureRoot();
      bindControls();
    }

    document.addEventListener("click", onQuickBuyClick, true);
    document.addEventListener("shopify:section:load", init);
    document.addEventListener("DOMContentLoaded", init);
    init();

    window.__ASPQuickBuy = { ready: true, open: openQuickBuy, close: closeOverlay };
    window.GP5QuickBuy = {
      _ready: true,
      handleButtonClick: function (event, btn) {
        if (event) { event.preventDefault(); event.stopPropagation(); }
        openQuickBuy(btn.getAttribute("data-product-handle"), btn.getAttribute("data-atc-action") || "add_to_cart", btn);
        return false;
      },
      open: openQuickBuy,
      init: init
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["odaki-color-variado"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__odkColorVariado) return;
    window.__odkColorVariado = true;

    function sectionOf(el) {
      return el.closest('.shopify-section') || document;
    }

    function formOf(el) {
      return sectionOf(el).querySelector('[data-pi-form]');
    }

    function propertyInput(form, name, create) {
      var selector = 'input[data-odk-cv-property]';
      var input = form.querySelector(selector);
      if (!input && create) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.setAttribute('data-odk-cv-property', '');
        form.appendChild(input);
      }
      if (input) input.name = 'properties[' + name + ']';
      return input;
    }

    function parts(id) {
      var dialog = document.getElementById(id);
      if (!dialog) return null;
      var scope = sectionOf(dialog);
      return {
        dialog: dialog,
        scope: scope,
        trigger: scope.querySelector('.odk-cv-trigger[data-odk-cv-open="' + id + '"]'),
        option: scope.querySelector('[data-odk-cv-option="' + id + '"]'),
        hint: scope.querySelector('[data-odk-cv-hint="' + id + '"]'),
        chosen: scope.querySelector('[data-odk-cv-chosen="' + id + '"]'),
        form: formOf(dialog)
      };
    }

    function clear(p) {
      if (!p) return;
      if (p.form) {
        var input = propertyInput(p.form, p.dialog.dataset.propertyName, false);
        if (input) input.remove();
      }
      if (p.trigger) p.trigger.classList.remove('is-selected');
      if (p.chosen) p.chosen.hidden = true;
      if (p.hint) p.hint.hidden = false;
      p.dialog.querySelectorAll('[data-odk-cv-color]').forEach(function (b) {
        b.setAttribute('aria-checked', 'false');
      });
      var confirm = p.dialog.querySelector('[data-odk-cv-confirm]');
      if (confirm) confirm.disabled = true;
    }

    function apply(p, color, hex) {
      if (!p.option || !p.form) return;
      // Selecciona la variante "Color Variado" a través del selector existente
      p.option.click();

      var input = propertyInput(p.form, p.dialog.dataset.propertyName, true);
      input.value = color;

      var position = p.option.dataset.optionPosition;
      var label = p.scope.querySelector('[data-pi-option-value="' + position + '"]');
      if (label) label.textContent = p.dialog.dataset.labelTemplate.replace('__COLOR__', color);

      if (p.trigger) p.trigger.classList.add('is-selected');
      if (p.hint) p.hint.hidden = true;
      if (p.chosen) {
        p.chosen.hidden = false;
        p.chosen.querySelector('[data-odk-cv-chosen-text]').textContent =
          p.dialog.dataset.chosenTemplate.replace('__COLOR__', color);
        p.chosen.querySelector('[data-odk-cv-chosen-dot]').style.background = hex;
      }
    }

    document.addEventListener('click', function (event) {
      var open = event.target.closest('[data-odk-cv-open]');
      if (open) {
        var dialog = document.getElementById(open.getAttribute('data-odk-cv-open'));
        if (dialog && dialog.showModal) {
          dialog.showModal();
          var checked = dialog.querySelector('[aria-checked="true"]') || dialog.querySelector('[data-odk-cv-color]');
          if (checked) checked.focus();
        }
        return;
      }

      var color = event.target.closest('[data-odk-cv-color]');
      if (color) {
        var dlg = color.closest('[data-odk-cv-dialog]');
        dlg.querySelectorAll('[data-odk-cv-color]').forEach(function (b) {
          b.setAttribute('aria-checked', b === color ? 'true' : 'false');
        });
        dlg.querySelector('[data-odk-cv-confirm]').disabled = false;
        return;
      }

      var confirm = event.target.closest('[data-odk-cv-confirm]');
      if (confirm) {
        var d = confirm.closest('[data-odk-cv-dialog]');
        var picked = d.querySelector('[data-odk-cv-color][aria-checked="true"]');
        if (!picked) return;
        apply(parts(d.id), picked.getAttribute('data-odk-cv-color'), picked.getAttribute('data-hex'));
        d.close();
        return;
      }

      var close = event.target.closest('[data-odk-cv-close]');
      if (close) {
        close.closest('[data-odk-cv-dialog]').close();
        return;
      }

      if (event.target.matches && event.target.matches('[data-odk-cv-dialog]')) {
        event.target.close();
      }
    });

    // Si eligen un color normal, se quita el "color a fabricar".
    // Fase de captura: corre antes que el selector del tema.
    document.addEventListener('click', function (event) {
      var swatch = event.target.closest('[data-pi-option]');
      if (!swatch || swatch.hasAttribute('data-odk-cv-option')) return;
      var scope = sectionOf(swatch);
      var option = scope.querySelector('[data-odk-cv-option][data-option-position="' + swatch.dataset.optionPosition + '"]');
      if (option) clear(parts(option.getAttribute('data-odk-cv-option')));
    }, true);

    // Teclado en la cuadrícula de colores
    document.addEventListener('keydown', function (event) {
      var color = event.target.closest && event.target.closest('[data-odk-cv-color]');
      if (!color) return;
      if (['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'].indexOf(event.key) === -1) return;
      event.preventDefault();
      var all = Array.prototype.slice.call(color.closest('[data-odk-cv-dialog]').querySelectorAll('[data-odk-cv-color]'));
      var i = all.indexOf(color);
      var next = all[(i + (event.key === 'ArrowRight' || event.key === 'ArrowDown' ? 1 : -1) + all.length) % all.length];
      next.focus();
      next.click();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["odaki-locale-toggle"] && !Shopify.designMode) return;
  try {
    (() => {
    const remember = () => {
      document.cookie = 'odaki_locale_pref=1; path=/; max-age=31536000; SameSite=Lax';
    };
    document.addEventListener('click', (event) => {
      const option = event.target.closest('[data-odk-locale-option]');
      if (!option) return;
      if (option.classList.contains('is-current')) {
        event.preventDefault();
        return;
      }
      remember();
      option.classList.add('is-loading');
    });
    document.addEventListener('click', (event) => {
      document.querySelectorAll('details[data-odk-locale][open]').forEach((d) => {
        if (!d.contains(event.target)) d.removeAttribute('open');
      });
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('details[data-odk-locale][open]').forEach((d) => d.removeAttribute('open'));
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["odaki-size-chart-table"] && !Shopify.designMode) return;
  try {
    (function () {
    var STORAGE_KEY = 'odaki-size-chart-unit';
    var CM_TO_IN = 1 / 2.54;

    function convertCmValueToInches(value) {
      if (!value) return value;

      return String(value)
        .split('-')
        .map(function (part) {
          var trimmed = part.trim();
          var number = parseFloat(trimmed);

          if (isNaN(number)) return trimmed;

          var inches = number * CM_TO_IN;
          return inches.toFixed(1).replace(/\.0$/, '');
        })
        .join('-');
    }

    function applyUnit(root, unit) {
      var isInches = unit === 'in';
      var label = root.querySelector('[data-unit-label]');
      var switchBtn = root.querySelector('[data-size-chart-switch]');
      var cmLabel = root.querySelector('.odaki-size-chart__unit-label--cm');
      var inLabel = root.querySelector('.odaki-size-chart__unit-label--in');

      root.querySelectorAll('[data-size-value]').forEach(function (cell) {
        var cmValue = cell.getAttribute('data-size-value');
        cell.textContent = isInches ? convertCmValueToInches(cmValue) : cmValue;
      });

      root.querySelectorAll('[data-size-chart-label]').forEach(function (heading) {
        heading.textContent = isInches ? heading.dataset.labelEn : heading.dataset.labelEs;
      });

      var note = root.querySelector('[data-size-chart-note]');
      if (note) {
        note.textContent = isInches ? note.dataset.noteEn : note.dataset.noteEs;
      }

      if (label) {
        label.textContent = isInches ? root.dataset.labelIn : root.dataset.labelCm;
      }

      if (switchBtn) {
        switchBtn.setAttribute('aria-checked', isInches ? 'true' : 'false');
        switchBtn.setAttribute(
          'aria-label',
          isInches ? root.dataset.toggleToCm : root.dataset.toggleToIn
        );
      }

      if (cmLabel) cmLabel.classList.toggle('is-active', !isInches);
      if (inLabel) inLabel.classList.toggle('is-active', isInches);

      root.dataset.currentUnit = unit;
    }

    function applyUnitToAll(unit) {
      document.querySelectorAll('[data-size-chart-root]').forEach(function (root) {
        applyUnit(root, unit);
      });
    }

    function initRoot(root) {
      var switchBtn = root.querySelector('[data-size-chart-switch]');
      if (!switchBtn || switchBtn.dataset.bound === 'true') return;

      switchBtn.dataset.bound = 'true';
      switchBtn.addEventListener('click', function () {
        var nextUnit = root.dataset.currentUnit === 'in' ? 'cm' : 'in';
        applyUnitToAll(nextUnit);

        try {
          sessionStorage.setItem(STORAGE_KEY, nextUnit);
        } catch (error) {
          /* ignore */
        }
      });
    }

    function boot() {
      var savedUnit = 'cm';

      try {
        savedUnit = sessionStorage.getItem(STORAGE_KEY) || 'cm';
      } catch (error) {
        savedUnit = 'cm';
      }

      document.querySelectorAll('[data-size-chart-root]').forEach(function (root) {
        initRoot(root);
      });

      applyUnitToAll(savedUnit === 'in' ? 'in' : 'cm');
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-detail-tabs"] && !Shopify.designMode) return;
  try {
    (function () {
    function measurePanelHeight(panel) {
      var wasHidden = panel.hasAttribute('hidden');

      if (wasHidden) {
        panel.removeAttribute('hidden');
        panel.style.display = 'block';
        panel.style.position = 'absolute';
        panel.style.visibility = 'hidden';
        panel.style.left = '0';
        panel.style.right = '0';
        panel.style.top = '0';
      }

      var height = panel.offsetHeight;

      if (wasHidden) {
        panel.setAttribute('hidden', '');
        panel.style.removeProperty('display');
        panel.style.removeProperty('position');
        panel.style.removeProperty('visibility');
        panel.style.removeProperty('left');
        panel.style.removeProperty('right');
        panel.style.removeProperty('top');
      }

      return height;
    }

    function syncStageHeight(root) {
      var stage = root.querySelector('[data-pi-detail-stage]');
      var panels = root.querySelectorAll('[data-pi-detail-panel]');
      if (!stage || !panels.length) return;

      var maxHeight = 0;
      panels.forEach(function (panel) {
        var height = measurePanelHeight(panel);
        if (height > maxHeight) maxHeight = height;
      });

      stage.style.minHeight = maxHeight + 'px';
    }

    function initTabs(root) {
      if (!root || root.dataset.bound === 'true') return;
      root.dataset.bound = 'true';

      var tabs = root.querySelectorAll('[data-pi-detail-tab]');
      var panels = root.querySelectorAll('[data-pi-detail-panel]');

      function activateTab(tab) {
        if (!tab) return;

        tabs.forEach(function (item) {
          var isActive = item === tab;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-selected', isActive ? 'true' : 'false');
          item.tabIndex = isActive ? 0 : -1;
        });

        panels.forEach(function (panel) {
          var isActive = panel.id === tab.getAttribute('aria-controls');
          panel.classList.toggle('is-active', isActive);
          if (isActive) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        });
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          activateTab(tab);
        });

        tab.addEventListener('keydown', function (event) {
          var index = Array.prototype.indexOf.call(tabs, tab);
          var nextIndex = index;

          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;

          if (nextIndex !== index) {
            event.preventDefault();
            activateTab(tabs[nextIndex]);
            tabs[nextIndex].focus();
          }
        });
      });

      syncStageHeight(root);

      var resizeTimer;
      window.addEventListener('resize', function () {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(function () {
          syncStageHeight(root);
        }, 150);
      });
    }

    function boot() {
      document.querySelectorAll('[data-pi-detail-tabs]').forEach(initTabs);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-info-variant-picker"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__odkSizeToggle) return;
    window.__odkSizeToggle = true;

    function setMode(toggle, mode, select) {
      var fieldset = toggle.closest('.pi-option');
      if (!fieldset) return;

      toggle.querySelectorAll('[data-odk-size-mode]').forEach(function (btn) {
        var active = btn.getAttribute('data-odk-size-mode') === mode;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      fieldset.querySelectorAll('[data-odk-size-group]').forEach(function (item) {
        item.hidden = item.getAttribute('data-odk-size-group') !== mode;
      });

      if (!select) return;

      var visible = Array.prototype.slice.call(
        fieldset.querySelectorAll('[data-odk-size-group="' + mode + '"] [data-pi-option]')
      );
      var current = visible.find(function (pill) {
        return pill.classList.contains('is-selected') && pill.getAttribute('aria-pressed') === 'true';
      });
      if (current) return;

      // Elige la primera talla disponible del grupo; si no hay, la primera.
      var target = visible.find(function (pill) {
        return !pill.classList.contains('is-unavailable');
      }) || visible[0];
      if (target) target.click();
    }

    function init(root) {
      (root || document).querySelectorAll('[data-odk-size-toggle]').forEach(function (toggle) {
        var fieldset = toggle.closest('.pi-option');
        var mode = 'adult';
        // Si la URL trae una variante infantil, se respeta.
        if (/[?&]variant=/.test(window.location.search) && fieldset) {
          var selected = fieldset.querySelector('[data-odk-size-group="kids"] [data-pi-option].is-selected');
          if (selected) mode = 'kids';
        }
        setMode(toggle, mode, true);
      });
    }

    document.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-odk-size-mode]');
      if (!btn) return;
      var toggle = btn.closest('[data-odk-size-toggle]');
      if (toggle) setMode(toggle, btn.getAttribute('data-odk-size-mode'), true);
    });

    window.addEventListener('load', function () { init(document); });
    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-rating"] && !Shopify.designMode) return;
  try {
    (function () {
    function closeAllPopovers() {
      document.querySelectorAll('[data-pr-popover]').forEach(function (popover) {
        if (popover.hidden) return;
        popover.hidden = true;
        var trigger = document.querySelector('[data-pr-toggle][aria-controls="' + popover.id + '"]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    }

    function openPopover(toggle, popover) {
      closeAllPopovers();
      popover.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
    }

    function scrollToTarget(hash) {
      if (!hash || hash.charAt(0) !== '#') return false;
      var target = document.querySelector(hash);
      if (!target || !target.scrollIntoView) return false;
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return true;
    }

    document.addEventListener('click', function (event) {
      var closeBtn = event.target.closest('[data-pr-close]');
      if (closeBtn) {
        closeAllPopovers();
        return;
      }

      var toggle = event.target.closest('[data-pr-toggle]');
      if (toggle) {
        var id = toggle.getAttribute('aria-controls');
        var popover = id ? document.getElementById(id) : null;
        if (!popover) return;
        var wasOpen = !popover.hidden;
        closeAllPopovers();
        if (!wasOpen) openPopover(toggle, popover);
        return;
      }

      var jumpLink = event.target.closest('[data-pr-jump]');
      if (jumpLink) {
        closeAllPopovers();
        if (scrollToTarget(jumpLink.getAttribute('href'))) {
          event.preventDefault();
        }
        return;
      }

      if (!event.target.closest('[data-pr-root]')) {
        closeAllPopovers();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAllPopovers();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-reviews"] && !Shopify.designMode) return;
  try {
    (function () {
    var odrState = {};

    function getContainers() {
      return document.querySelectorAll('[data-odaki-reviews]');
    }

    function getState(container) {
      var id = container.getAttribute('data-product-id');
      if (!odrState[id]) {
        odrState[id] = {
          totalRatings: parseInt(container.getAttribute('data-total-ratings'), 10) || 0,
          sumRatings: parseFloat(container.getAttribute('data-sum-ratings')) || 0,
          listCount: parseInt(container.getAttribute('data-list-count'), 10) || 0,
          scaleMax: parseInt(container.getAttribute('data-scale-max'), 10) || 5,
          stars: {
            5: parseInt(container.getAttribute('data-star-5'), 10) || 0,
            4: parseInt(container.getAttribute('data-star-4'), 10) || 0,
            3: parseInt(container.getAttribute('data-star-3'), 10) || 0,
            2: parseInt(container.getAttribute('data-star-2'), 10) || 0,
            1: parseInt(container.getAttribute('data-star-1'), 10) || 0
          }
        };
      }
      return odrState[id];
    }

    function initialsFromName(name) {
      var parts = String(name || '').trim().split(/\s+/).filter(Boolean);
      if (!parts.length) return '?';
      var initials = parts[0].charAt(0);
      if (parts.length > 1) {
        initials += parts[parts.length - 1].charAt(0);
      }
      return initials.toUpperCase();
    }

    function formatDate(date) {
      try {
        return new Intl.DateTimeFormat('es', { day: 'numeric', month: 'long', year: 'numeric' }).format(date);
      } catch (err) {
        return date.toLocaleDateString();
      }
    }

    function formatCommentedOn(container, date) {
      var template = container.getAttribute('data-i18n-commented-on') || '__DATE__';
      return template.replace('__DATE__', formatDate(date));
    }

    function renderStats(container, state) {
      var average = state.totalRatings > 0 ? state.sumRatings / state.totalRatings : 0;
      var averageRounded = Math.round(average * 10) / 10;
      var floorValue = Math.floor(average);
      var decimal = average - floorValue;
      var decimalStep = 0;
      if (decimal >= 0.3 && decimal <= 0.7) {
        decimalStep = 0.5;
      } else if (decimal > 0.7) {
        decimalStep = 1;
      }

      var averageText = container.querySelector('[data-odr-average-text]');
      var countText = container.querySelector('[data-odr-total-count]');
      var starsEl = container.querySelector('[data-odr-average-stars]');
      var totalTemplate = container.getAttribute('data-i18n-total-ratings') || '';
      var noRatingsText = container.getAttribute('data-i18n-no-ratings') || '';
      var ratingAriaTemplate = container.getAttribute('data-i18n-rating-aria') || '';

      var ofMaxTemplate = container.getAttribute('data-i18n-of-max') || 'de __MAX__';

      if (state.totalRatings > 0) {
        if (averageText) {
          averageText.textContent = averageRounded + ' ' + ofMaxTemplate.replace('__MAX__', String(state.scaleMax));
        }
        if (countText) {
          countText.textContent = totalTemplate.replace('__COUNT__', state.totalRatings);
        }
      } else {
        if (averageText) averageText.innerHTML = '&nbsp;';
        if (countText) countText.textContent = noRatingsText;
      }

      if (starsEl) {
        starsEl.style.setProperty('--odr-rating', String(floorValue));
        starsEl.style.setProperty('--odr-rating-decimal', String(decimalStep));
        starsEl.setAttribute('aria-label', ratingAriaTemplate.replace('__RATING__', String(averageRounded)));
      }

      var breakdown = container.querySelector('[data-odr-breakdown]');
      if (breakdown) {
        [5, 4, 3, 2, 1].forEach(function (star) {
          var row = breakdown.querySelector('[data-odr-bar="' + star + '"]');
          if (!row) return;
          var count = state.stars[star] || 0;
          var pct = state.listCount > 0 ? Math.round((count / state.listCount) * 100) : 0;
          var fill = row.querySelector('[data-odr-bar-fill]');
          var countEl = row.querySelector('[data-odr-bar-count]');
          if (fill) fill.style.width = pct + '%';
          if (countEl) countEl.textContent = pct + '%';
        });

        var note = breakdown.querySelector('[data-odr-breakdown-note]');
        if (note) {
          note.hidden = !(state.listCount > 0 && state.totalRatings !== state.listCount);
        }
      }

      var feedCount = container.querySelector('[data-odr-feed-count]');
      if (feedCount) {
        feedCount.textContent = state.listCount > 0 ? '(' + state.listCount + ')' : '';
      }
    }

    function addReviewCard(container, review) {
      var template = container.querySelector('[data-odr-card-template]');
      var list = container.querySelector('[data-odr-feed-list]');
      if (!template || !list) return;

      var fragment = template.content.cloneNode(true);
      var card = fragment.querySelector('.odr-card');
      var avatar = fragment.querySelector('[data-odr-card-avatar]');
      var nameEl = fragment.querySelector('[data-odr-card-name]');
      var dateEl = fragment.querySelector('[data-odr-card-date]');
      var starsEl = fragment.querySelector('[data-odr-card-stars]');
      var titleEl = fragment.querySelector('[data-odr-card-title]');
      var bodyEl = fragment.querySelector('[data-odr-card-body]');

      if (avatar) avatar.textContent = initialsFromName(review.author);
      if (nameEl) nameEl.textContent = review.author;
      if (dateEl) dateEl.textContent = review.dateLabel || '';
      if (titleEl) titleEl.textContent = review.title;
      if (bodyEl) bodyEl.textContent = review.body;
      if (starsEl) {
        starsEl.style.setProperty('--odr-rating', String(review.rating));
        starsEl.style.setProperty('--odr-rating-max', '5');
        starsEl.style.setProperty('--odr-rating-decimal', '0');
      }

      list.insertBefore(fragment, list.firstChild);

      var empty = container.querySelector('[data-odr-empty]');
      if (empty) empty.hidden = true;

      if (card) {
        setTimeout(function () {
          card.classList.remove('odr-card--new');
        }, 1200);
      }
    }

    function getStoredReviews(storageKey) {
      try {
        var raw = window.localStorage.getItem(storageKey);
        return raw ? JSON.parse(raw) : [];
      } catch (err) {
        return [];
      }
    }

    function saveStoredReview(storageKey, review) {
      try {
        var reviews = getStoredReviews(storageKey);
        reviews.unshift(review);
        if (reviews.length > 100) reviews.length = 100;
        window.localStorage.setItem(storageKey, JSON.stringify(reviews));
      } catch (err) {
        /* localStorage puede fallar en modo privado; se ignora silenciosamente */
      }
    }

    function restoreStoredReviews(container) {
      var storageKey = container.getAttribute('data-storage-key');
      if (!storageKey) return;
      var reviews = getStoredReviews(storageKey);
      if (!reviews.length) return;

      var state = getState(container);
      reviews.slice().reverse().forEach(function (review) {
        addReviewCard(container, review);
        state.totalRatings += 1;
        state.sumRatings += review.rating;
        state.listCount += 1;
        state.stars[review.rating] = (state.stars[review.rating] || 0) + 1;
      });
      renderStats(container, state);
    }

    function openModal(container) {
      var modal = container.querySelector('[data-odr-modal]');
      if (!modal) {
        modal = document.querySelector('dialog.odr-modal[data-odr-owner="' + container.getAttribute('data-product-id') + '"]');
      }
      if (!modal) return;

      /* Move to <body> so position:fixed is never trapped by overflow/transform ancestors. */
      if (modal.parentElement !== document.body) {
        modal.setAttribute('data-odr-owner', container.getAttribute('data-product-id') || '');
        document.body.appendChild(modal);
      }

      if (typeof modal.showModal === 'function') {
        if (!modal.open) modal.showModal();
      } else {
        modal.setAttribute('open', 'open');
      }
    }

    function closeModal(modal) {
      if (!modal) return;
      resetForm(modal);
      if (typeof modal.close === 'function') {
        if (modal.open) modal.close();
      } else {
        modal.removeAttribute('open');
      }
    }

    function resetForm(modal) {
      var form = modal.querySelector('[data-odr-form]');
      var success = modal.querySelector('[data-odr-success]');
      var ratingInput = modal.querySelector('[data-odr-rating-input]');
      var ratingError = modal.querySelector('[data-odr-rating-error]');

      if (form) {
        form.hidden = false;
        form.reset();
      }
      if (success) success.hidden = true;
      if (ratingInput) ratingInput.value = '0';
      if (ratingError) ratingError.hidden = true;

      modal.querySelectorAll('[data-odr-star]').forEach(function (btn) {
        btn.classList.remove('is-filled', 'is-hover');
      });
    }

    function setStarSelection(picker, value) {
      picker.querySelectorAll('[data-odr-star]').forEach(function (btn) {
        var starValue = parseInt(btn.getAttribute('data-odr-star'), 10);
        btn.classList.toggle('is-filled', starValue <= value);
      });
    }

    function previewStarHover(picker, value) {
      picker.querySelectorAll('[data-odr-star]').forEach(function (btn) {
        var starValue = parseInt(btn.getAttribute('data-odr-star'), 10);
        btn.classList.toggle('is-hover', starValue <= value);
      });
    }

    function handleSubmit(form) {
      var modal = form.closest('[data-odr-modal]');
      if (!modal) return;
      var ownerId = modal.getAttribute('data-odr-owner');
      var container = form.closest('[data-odaki-reviews]');
      if (!container && ownerId) {
        container = document.querySelector('[data-odaki-reviews][data-product-id="' + ownerId + '"]');
      }
      if (!container) return;

      var ratingInput = form.querySelector('[data-odr-rating-input]');
      var ratingError = form.querySelector('[data-odr-rating-error]');
      var rating = parseInt(ratingInput ? ratingInput.value : '0', 10) || 0;

      var authorInput = form.querySelector('[data-odr-input="author"]');
      var titleInput = form.querySelector('[data-odr-input="title"]');
      var bodyInput = form.querySelector('[data-odr-input="body"]');

      var author = authorInput ? authorInput.value.trim() : '';
      var title = titleInput ? titleInput.value.trim() : '';
      var body = bodyInput ? bodyInput.value.trim() : '';

      if (rating < 1) {
        if (ratingError) ratingError.hidden = false;
        return;
      }
      if (ratingError) ratingError.hidden = true;

      if (!author || !title || !body) {
        form.reportValidity();
        return;
      }

      var submitBtn = form.querySelector('[data-odr-submit]');
      var submitLabel = form.querySelector('[data-odr-submit-label]');
      var spinner = form.querySelector('[data-odr-spinner]');
      var sendingText = container.getAttribute('data-i18n-sending');
      var submitText = container.getAttribute('data-i18n-submit');

      if (submitBtn) submitBtn.disabled = true;
      if (spinner) spinner.hidden = false;
      if (submitLabel && sendingText) submitLabel.textContent = sendingText;

      var payload = {
        product_id: container.getAttribute('data-product-id'),
        rating: rating,
        author: author,
        title: title,
        body: body
      };

      var submitUrl = container.getAttribute('data-submit-url');
      var request;

      if (window.fetch && submitUrl) {
        var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
        var timeout = controller ? setTimeout(function () { controller.abort(); }, 6000) : null;

        request = fetch(submitUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
          signal: controller ? controller.signal : undefined
        }).catch(function () {
          /* Sin backend disponible todavia: se continua con la actualizacion local */
        }).finally(function () {
          if (timeout) clearTimeout(timeout);
        });
      } else {
        request = Promise.resolve();
      }

      request.then(function () {
        finishSubmit(container, modal, form, {
          rating: rating,
          author: author,
          title: title,
          body: body
        });
      }).finally(function () {
        if (submitBtn) submitBtn.disabled = false;
        if (spinner) spinner.hidden = true;
        if (submitLabel && submitText) submitLabel.textContent = submitText;
      });
    }

    function finishSubmit(container, modal, form, data) {
      var now = new Date();
      var review = {
        rating: data.rating,
        author: data.author,
        title: data.title,
        body: data.body,
        dateLabel: formatCommentedOn(container, now),
        createdAt: now.toISOString()
      };

      var storageKey = container.getAttribute('data-storage-key');
      if (storageKey) saveStoredReview(storageKey, review);

      addReviewCard(container, review);

      var state = getState(container);
      state.totalRatings += 1;
      state.sumRatings += review.rating;
      state.listCount += 1;
      state.stars[review.rating] = (state.stars[review.rating] || 0) + 1;
      renderStats(container, state);

      var success = modal.querySelector('[data-odr-success]');
      if (success) {
        form.hidden = true;
        success.hidden = false;
      }

      setTimeout(function () {
        closeModal(modal);
      }, 2200);
    }

    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-odr-open]');
      if (opener) {
        var container = opener.closest('[data-odaki-reviews]');
        if (container) openModal(container);
        return;
      }

      var closer = event.target.closest('[data-odr-close]');
      if (closer) {
        var modal = closer.closest('[data-odr-modal]');
        if (modal) closeModal(modal);
        return;
      }

      var backdropModal = event.target.closest('[data-odr-modal]');
      if (backdropModal && event.target === backdropModal) {
        closeModal(backdropModal);
        return;
      }

      var star = event.target.closest('[data-odr-star]');
      if (star) {
        var picker = star.closest('[data-odr-star-picker]');
        var value = parseInt(star.getAttribute('data-odr-star'), 10);
        if (picker) {
          setStarSelection(picker, value);
          var form = picker.closest('[data-odr-form]');
          var ratingInput = form ? form.querySelector('[data-odr-rating-input]') : null;
          if (ratingInput) ratingInput.value = String(value);
        }
      }
    });

    document.addEventListener('mouseover', function (event) {
      var star = event.target.closest('[data-odr-star]');
      if (!star) return;
      var picker = star.closest('[data-odr-star-picker]');
      var value = parseInt(star.getAttribute('data-odr-star'), 10);
      if (picker) previewStarHover(picker, value);
    });

    document.addEventListener('mouseout', function (event) {
      var picker = event.target.closest('[data-odr-star-picker]');
      if (!picker) return;
      var related = event.relatedTarget;
      if (related && picker.contains(related)) return;
      var selected = picker.querySelectorAll('.is-filled').length;
      previewStarHover(picker, selected);
    });

    document.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-odr-form]');
      if (!form) return;
      event.preventDefault();
      handleSubmit(form);
    });

    function initReviews() {
      getContainers().forEach(function (container) {
        if (container.getAttribute('data-odr-initialized')) return;
        container.setAttribute('data-odr-initialized', 'true');
        getState(container);
        restoreStoredReviews(container);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initReviews);
    } else {
      initReviews();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-size-guide-modal"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-size-guide-open]');
    if (opener) {
      var targetId = opener.getAttribute('data-size-guide-open');
      var modal = targetId ? document.getElementById(targetId) : null;
      if (modal) openSizeGuide(modal);
      return;
    }

    var closer = event.target.closest('[data-size-guide-close]');
    if (closer) {
      var openModal = closer.closest('[data-size-guide-modal]');
      if (openModal) closeSizeGuide(openModal);
      return;
    }

    var next = event.target.closest('[data-size-guide-next]');
    if (next) {
      var modalNext = next.closest('[data-size-guide-modal]');
      if (modalNext) moveSizeGuide(modalNext, 1);
      return;
    }

    var prev = event.target.closest('[data-size-guide-prev]');
    if (prev) {
      var modalPrev = prev.closest('[data-size-guide-modal]');
      if (modalPrev) moveSizeGuide(modalPrev, -1);
      return;
    }

    var dot = event.target.closest('[data-size-guide-dot]');
    if (dot) {
      var modalDot = dot.closest('[data-size-guide-modal]');
      if (modalDot) {
        var index = parseInt(dot.getAttribute('data-size-guide-dot'), 10) || 0;
        setSizeGuideIndex(modalDot, index);
      }
      return;
    }

    var slide = event.target.closest('[data-size-guide-slide]');
    if (slide) {
      var modalSlide = slide.closest('[data-size-guide-modal]');
      if (modalSlide) {
        var slides = Array.prototype.slice.call(modalSlide.querySelectorAll('[data-size-guide-slide]'));
        var slideIndex = slides.indexOf(slide);
        if (slideIndex > -1) setSizeGuideIndex(modalSlide, slideIndex);
      }
    }
  });

  document.addEventListener('keydown', function (event) {
    var modal = document.querySelector('[data-size-guide-modal].is-open');
    if (!modal) return;
    if (event.key === 'Escape') {
      closeSizeGuide(modal);
    } else if (event.key === 'ArrowRight') {
      moveSizeGuide(modal, 1);
    } else if (event.key === 'ArrowLeft') {
      moveSizeGuide(modal, -1);
    }
  });

  function buildSizeGuideDots(modal) {
    var dotsWrap = modal.querySelector('[data-size-guide-dots]');
    var slides = modal.querySelectorAll('[data-size-guide-slide]');
    if (!dotsWrap || dotsWrap.childElementCount === slides.length) return;
    dotsWrap.innerHTML = '';
    slides.forEach(function (slide, index) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'pi-size-guide-modal__dot';
      dot.setAttribute('data-size-guide-dot', String(index));
      if (index === 0) dot.classList.add('is-active');
      dotsWrap.appendChild(dot);
    });
  }

  function setSizeGuideIndex(modal, index) {
    var slides = modal.querySelectorAll('[data-size-guide-slide]');
    if (!slides.length) return;
    var total = slides.length;
    var next = ((index % total) + total) % total;
    modal.setAttribute('data-size-guide-current', String(next));

    slides.forEach(function (slide, i) {
      var raw = i - next;
      if (raw > total / 2) raw -= total;
      if (raw < -total / 2) raw += total;
      var distance = Math.abs(raw);
      var translate = raw * 62;
      var scale = Math.max(1 - distance * 0.18, 0.58);
      var opacity = distance === 0 ? 1 : distance === 1 ? 0.5 : distance === 2 ? 0.2 : 0;

      slide.style.transform = 'translateX(' + translate + '%) scale(' + scale + ')';
      slide.style.opacity = String(opacity);
      slide.style.zIndex = String(10 - distance);
      slide.classList.toggle('is-active', distance === 0);
      slide.style.pointerEvents = distance <= 2 ? 'auto' : 'none';
    });

    modal.querySelectorAll('[data-size-guide-dot]').forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === next);
    });
  }

  function moveSizeGuide(modal, delta) {
    var current = parseInt(modal.getAttribute('data-size-guide-current'), 10) || 0;
    setSizeGuideIndex(modal, current + delta);
  }

  function openSizeGuide(modal) {
    buildSizeGuideDots(modal);
    setSizeGuideIndex(modal, 0);
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () {
      modal.classList.add('is-open');
    });
    document.documentElement.classList.add('pi-size-guide-lock');
  }

  function closeSizeGuide(modal) {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('pi-size-guide-lock');
    setTimeout(function () {
      modal.hidden = true;
    }, 150);
  }
  } catch(e) { console.error(e); }
})();

})();
